import { Store } from '@ngrx/store';
// services
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
// NgRx actions / selectors
import { addWatchlistItem, removeWatchlistItem, removeWatchlistItemError, setWatchlistItemError, } from '../state/add-to-watchlist-modal.actions';
// Constants
import { ADD_TO_WATCHLIST_STATE_SLICE_KEY } from '../state/add-to-watchlist-modal.reducer';
import { ERROR_MESSAGE_DICT } from '../state/constants';
import * as i0 from "@angular/core";
import * as i1 from "WatchlistApp/ts/services/watchlists.service";
import * as i2 from "@ngrx/store";
import * as i3 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
/**
 *
 * WatchlistGroupElementComponent Component
 *
 * This component is responsible for displaying a list of watshlists on the left-hand column "watching on" and
 * the ability to remove a watchlist. Thus, displaying that watchlist on the right-hand column "other watchlists". With
 * the ability to "add to watchlist" after it was removed and vice versa.
 *
 *
 * *Inputs Properties:
 * watchlistData: An object containing watchlist data.
 * watchlistGroupType: Whether or not the group of watchlistGroupData is containing or excluding a security.
 */
export class WatchlistGroupElementComponent {
    constructor(watchlistsService, store) {
        this.watchlistsService = watchlistsService;
        this.store = store;
        this.mapStateToComponent = (state) => {
            this.securityObject = state.securityObject;
        };
        this.storeSubscription = this.store
            .select(ADD_TO_WATCHLIST_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    ngOnInit() {
        if (this.watchlistGroupType === 'containing') {
            // The "substract" here is the actual name of the CSS class/SVG for the subtract icon
            this.iconClass = 'icon-substract';
            this.tooltipTitle = 'Remove from Watchlist';
        }
        else {
            this.iconClass = 'icon-add';
            this.tooltipTitle = 'Add to Watchlist';
        }
    }
    watchlistClickHandler() {
        const watchlistId = this.watchlistData.id;
        const itemId = this.securityObject.securitylist_security_id.slice(1);
        const itemType = this.securityObject.security_type;
        this.store.dispatch(removeWatchlistItemError());
        const watchlistItem = {
            securityId: this.securityObject.security_id,
            securityType: this.securityObject.security_type,
        };
        if (this.watchlistGroupType === 'containing') {
            // Optimistically updating the state before making AJAX call, so user has better experience.
            this.store.dispatch(removeWatchlistItem({ watchlist: this.watchlistData, watchlistItem }));
            this.watchlistsService.deleteWatchlistItem(watchlistId, itemId, itemType).subscribe({
                next: () => {
                    this.store.dispatch(removeWatchlistItemError());
                },
                error: () => {
                    this.store.dispatch(addWatchlistItem({ watchlist: this.watchlistData, watchlistItem }));
                    this.store.dispatch(setWatchlistItemError({ errorMessage: ERROR_MESSAGE_DICT.INVALID_WATCHLIST_ITEM_REMOVE }));
                },
            });
            this.store.dispatch(removeWatchlistItem({ watchlist: this.watchlistData, watchlistItem }));
        }
        else {
            this.store.dispatch(addWatchlistItem({ watchlist: this.watchlistData, watchlistItem }));
            this.watchlistsService.postWatchlistItem(watchlistId, itemId, itemType).subscribe({
                next: () => {
                    this.store.dispatch(removeWatchlistItemError());
                },
                error: () => {
                    this.store.dispatch(setWatchlistItemError({ errorMessage: ERROR_MESSAGE_DICT.INVALID_WATCHLIST_ITEM_ADD }));
                    this.store.dispatch(removeWatchlistItem({ watchlist: this.watchlistData, watchlistItem }));
                },
            });
        }
    }
}
WatchlistGroupElementComponent.ɵfac = function WatchlistGroupElementComponent_Factory(t) { return new (t || WatchlistGroupElementComponent)(i0.ɵɵdirectiveInject(i1.WatchlistsService), i0.ɵɵdirectiveInject(i2.Store)); };
WatchlistGroupElementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WatchlistGroupElementComponent, selectors: [["ycn-watchlist-group-element"]], inputs: { watchlistData: "watchlistData", watchlistGroupType: "watchlistGroupType" }, decls: 7, vars: 4, consts: [[1, "linked-list-item"], [1, "linked-list-item-header"], [3, "textContent"], [1, "linked-list-item-controls"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "tooltipPlacement", "tooltipTitle"], ["ycnIcon", "", 3, "name"]], template: function WatchlistGroupElementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "span", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "a", 4);
        i0.ɵɵlistener("click", function WatchlistGroupElementComponent_Template_a_click_4_listener() { return ctx.watchlistClickHandler(); });
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 5);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.watchlistData.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipPlacement", "left")("tooltipTitle", ctx.tooltipTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", ctx.iconClass);
    } }, dependencies: [i3.IconDirective, i4.TooltipDirective], encapsulation: 2 });
